// Liczba odlicza od zera, a słowo „tasuje się” (ScrambleText). Szerokość zostaje stała, żeby nic obok nie skakało.
import {gsap} from "./shared";

export function tickText(el, {duration = 1.4, delay = 0} = {}) {
    const text = el?.textContent.trim();
    if (!text) {
        return null;
    }
    el.style.minWidth = `${el.getBoundingClientRect().width}px`;

    if (/^\d{1,6}$/.test(text)) {
        const state = {value: 0};
        el.textContent = "0";
        return gsap.to(state, {
            value: parseInt(text, 10),
            duration,
            delay,
            ease: "power3.out",
            onUpdate: () => {
                el.textContent = String(Math.round(state.value));
            },
            onComplete: () => {
                el.textContent = text;
            }
        });
    }

    return gsap.to(el, {
        duration: Math.min(1.4, 0.5 + text.length * 0.12),
        delay,
        ease: "none",
        scrambleText: {text, chars: "ABCDEFGHIJKLMNOPRSTUWXYZ", speed: 0.6, revealDelay: 0.25}
    });
}
